import { ResponseList } from "./response.model";

export class GolfCourseListResponse{
    courseList: GolfCourse[]= [];
    totalpages=0;
    totalCourses= 0;
    page=0;
}
export class GolfCourse{
    id_course = "";
    iGolfId = "";
    active= true;
    address1="";
    address2="";
    city="";
    id_country=0;
    countryFull="";
    countryShort="";
    courseName="";
    email="";
    gpsAvailable=0;
    layoutHoles=0;
    layoutTotalHoles=0;
    layoutName="";
    otherState="";
    id_state=0;
    stateFull="";
    stateShort="";
    zipCode="";
    scorecardAvailable= 0;
    syncOutputAvailable=0;
    vectorAvailable=0;
    elevationAvailable=0;
    conditionRating=0;
    recommendRating=0;
    distance=0;
    latitude=0;
    longitude=0;
    teeTimesAvailable=0;
    classification="";
    id_language=0;
    favoriteCourse=0;
    oneMeterElevationAvailable=0;
    countryCode="";
}
export class VectorGPSResponse{
    ErrorMessage= "";
    status= 1;
    id_course= "";
    lastModified= "";
    vectorGPSObject= new VectorGpsModel();
}
export class VectorGpsModel{
    Background: ShapeResponseModel= new ShapeResponseModel();
    Bridge:ShapeResponseModel= new ShapeResponseModel();
    Clubhouse: ShapeResponseModel = new ShapeResponseModel();
    Creek: ShapeResponseModel = new ShapeResponseModel();
    Path: ShapeResponseModel= new ShapeResponseModel();
    Tree: ShapeResponseModel = new ShapeResponseModel();
    Water: ShapeResponseModel = new ShapeResponseModel();
    HoleCount= 0;
    Holes: HoleResponseModel= new HoleResponseModel();
}
export class ShapeResponseModel{
    ShapeCount= 0;
    Shapes: ShapesModel= new ShapesModel();
}
export class ShapesModel{
    Shape: ShapeModel[]=[];
}
export class ShapeModel{
    Points="";
}
export class HoleResponseModel {
 Hole: HoleModel[]=[];
}
export class HoleModel{
    Bunker: ShapeResponseModel= new ShapeResponseModel();
    CentralPath: ShapeResponseModel= new ShapeResponseModel();
    Fairway: ShapeResponseModel= new ShapeResponseModel();
    Green: ShapeResponseModel= new ShapeResponseModel();
    Greencenter: ShapeResponseModel= new ShapeResponseModel();
    Perimeter: ShapeResponseModel= new ShapeResponseModel();
    Teebox: ShapeResponseModel= new ShapeResponseModel();
    TeeboxCenter: ShapeResponseModel= new ShapeResponseModel();
    HoleNumber= 0
}
export class ScoreCardResponse{
    ErrorMessage= "";
    status= 1;
    id_course= "";
    lastModified= "";
    menScorecardList: ScoreCardModel[]=[];
    wmnScorecardList: ScoreCardModel[]=[];
}
export class ScoreCardModel{
    hcpHole: number[]=[];
    parHole: number[]=[];
    parIn= 0;
    parOut= 0;
    parTotal= 0;
}
export class Hole{
    hole: HoleModel= new HoleModel();
    par= "";
}
